import { Link, useRouter } from "@/lib/router";
import { cn } from "@/lib/utils";
import { Target, Trophy, PlusCircle, User } from "lucide-react";
import { Button } from "@/components/ui/button";

const CURRENT_USER_ID = "u1";

const navItems = [
	{ path: "/", label: "Bounties", icon: Target },
	{ path: "/leaderboard", label: "Leaderboard", icon: Trophy },
];

export function Navbar() {
	const { path, navigate } = useRouter();

	return (
		<header className="sticky top-0 z-50 border-b border-border bg-background/80 backdrop-blur-md">
			<div className="container mx-auto flex h-16 items-center justify-between px-4">
				<div className="flex items-center gap-8">
					<Link to="/" className="font-bold text-lg">
						<span>App Bounty</span>
					</Link>

					<nav className="hidden md:flex items-center gap-1">
						{navItems.map((item) => {
							const Icon = item.icon;
							const isActive =
								item.path === "/"
									? path === "/" || path.startsWith("/bounty")
									: path.startsWith(item.path);
							return (
								<Link
									key={item.path}
									to={item.path}
									className={cn(
										"flex items-center gap-2 rounded-md px-3 py-2 text-sm font-medium transition-colors",
										isActive
											? "bg-secondary text-foreground"
											: "text-muted-foreground hover:text-foreground hover:bg-secondary/50"
									)}
								>
									<Icon className="h-4 w-4" />
									{item.label}
								</Link>
							);
						})}
					</nav>
				</div>

				<div className="flex items-center gap-3">
					<Button
						size="sm"
						onClick={() => navigate("/bounty/new")}
						className="gap-2"
					>
						<PlusCircle className="h-4 w-4" />
						<span className="hidden sm:inline">Post Bounty</span>
					</Button>
					<button
						onClick={() => navigate(`/profile/${CURRENT_USER_ID}`)}
						className={cn(
							"flex h-8 w-8 items-center justify-center rounded-full bg-primary text-primary-foreground text-xs font-bold transition-opacity hover:opacity-80"
						)}
					>
						<User className="h-4 w-4" />
					</button>
				</div>
			</div>
		</header>
	);
}
